import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'updated'})
export class UpdatedPipe implements PipeTransform {
  transform(data: any): string {
    return data.modifierTime.substr(0, 19).replace('T', ' ') + (data.modifierUser ? ' by ' + data.modifierUser.realname : '');
  }
}
